import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import JobsTable from '../jobs/jobs-table.jsx';
import DriversTable from '../drivers/drivers-table.jsx';
import PortalAccountsTable from '../portal-admin/portal-accounts-table.jsx';
import CustomersTable from '../customers/customers-table.jsx';
export default class PortalSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      searchResults: props.searchResults || {
        jobs: [],
        users: [],
        drivers: [],
        vehicles: [],
        customers: [],
        pickup_addresses: [],
        dropoff_addresses: [],
        customerAllJobsPage:false
      },
      numberOfSearchResults: '0',
      searchFor: '',
      searchForLabel: '',
      pluralResults: 's',
      isFetching: false,
      searchResultsJobs: [],
      searchResultsUsers: [],
      searchResultsDrivers: [],
      searchResultsCustomers: []
    };
    this.handleSearchInput = this.handleSearchInput.bind(this);
  }
  componentDidMount() {
    let isCustomerLogin = $('#data-compnay-id').attr('data-is-customer-login');
    isCustomerLogin = ((isCustomerLogin == 1) ? true : false);
    this.setState({customerAllJobsPage: isCustomerLogin});
    if(isCustomerLogin){
      $('#react-component-g4-logistics-portal-search').find('.search-results').attr('id','react-component-g4-logistics-portal-view-customer-with-all-jobs');  
    }
  }
  handleSearchInput() {
    let that = this;
    let searchFor = document.getElementById(
      'modal-search-input-box'
    ).value;
    let searchForLabel;
    setTimeout(function () {
      if (searchFor.length > 1) {
        let formData = new FormData();
        formData.append(
          'search_for', searchFor
        );
        formData.append(
          'is_customer_login',that.state.customerAllJobsPage
        );
        fetch("/api/v1/portal/search", {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            ,"Accept": 'application/json'
          },
          body: formData,
        }).
        then((responseText) => {
          let response = responseText.json();
          response.then((searchResults) => {
            let plural = 's';
            if (searchResults.length == 1) {
              plural = '';
            }
            if (searchFor.length > 0) {
              searchForLabel = ' for <em>' + searchFor + '</em>';
            }
            else {
              searchForLabel = '<em>' + searchFor + '</em>';
            }
            const jobs = Object.keys(
              searchResults.jobs).map(
              i => searchResults.jobs[i]
            );
            const users = Object.keys(
              searchResults.users).map(
              j => searchResults.users[j]
            );
            const drivers = Object.keys(
              searchResults.drivers).map(
              k => searchResults.drivers[k]
            );
            const customers = Object.keys(
              searchResults.customers).map(
              l => searchResults.customers[l]
            );
            this.setState({
              searchResults: searchResults,
              numberOfSearchResults: (!that.state.customerAllJobsPage) ? jobs.length + users.length + customers.length + drivers.length : jobs.length,
              pluralResults: plural,
              searchFor: searchFor,
              searchForLabel: searchForLabel,
              isFetching: false,
              searchResultsJobs: jobs,
              searchResultsUsers: users,
              searchResultsDrivers: drivers,
              searchResultsCustomers: customers,
              isFetching: true
            });
          });
        });
      }
    }.bind(this), 2000)
  }
  componentWillUpdate() {
    let that = this;
    setTimeout(function() {
      that.setState({
        isFetching: false,
      });
    }, 2000);
  }
  render() {
    return (
      <div>
        <div id="search-modal-search-form">
          <div id="search-main-controls-container">
            <input
              type="text"
              id="modal-search-input-box"
              placeholder="type to search..."
              autoComplete="off"
              className="form-control form-control-lg"
              onChange={this.handleSearchInput}
              style={{"width":"90%", "display":"inline"}}/>
            <button
              id="modal-search-button"
              className="btn btn-lg btn-dark"
              style={{"width":"50px"}}>
              <i className="fa fa-search" alt="[Search]"></i>
            </button>
          </div>
        </div>

        <div id="search-results" className="panel">
          <h2 id="search-results-number-of-search-results">
            {this.state.numberOfSearchResults
            } search result{this.state.pluralResults}
            <span dangerouslySetInnerHTML={{__html:this.state.searchForLabel}}>
            </span>
          </h2>
          <div className="search-results">
          {
            this.state.isFetching ?
            'Getting Search Results...' :
              <div>
                <ul className="nav nav-tabs">
                  <li>
                    <a data-toggle="tab" href="#search-results-tabs-jobs-tab"
                       className="active show">
                      Jobs ({this.state.searchResultsJobs.length})
                    </a>
                  </li>
                  {(!this.state.customerAllJobsPage) ? 
                  <li>
                    <a data-toggle="tab" href="#search-results-tabs-users-tab">
                      Users ({this.state.searchResultsUsers.length})
                    </a>
                  </li>
                  : null}
                  {(!this.state.customerAllJobsPage) ? 
                  <li>
                    <a data-toggle="tab" href="#search-results-tabs-drivers-tab">
                      Drivers ({this.state.searchResultsDrivers.length})
                    </a>
                  </li> 
                  : null}
                  {(!this.state.customerAllJobsPage) ? 
                  <li>
                    <a data-toggle="tab" href="#search-results-tabs-customers-tab">
                      Customers ({this.state.searchResultsCustomers.length})
                    </a>
                  </li>
                   : null}
                </ul>
                <div className="tab-content-container">
                  <div className="tab-content">
                    <div id="search-results-tabs-jobs-tab"
                         className="tab-pane fade in active show">
                      <JobsTable
                        jobs = {this.state.searchResultsJobs}
                        message_if_none = 'Job not found or available for viewing.'
                        key={"portal-search-result-jobs-table"}
                        customerAllJobsPage={this.state.customerAllJobsPage}
                      />
                    </div>
                    <div id="search-results-tabs-users-tab"
                         className="tab-pane fade">
                      <PortalAccountsTable
                        portal_accounts = {this.state.searchResultsUsers}
                        message_if_none = 'User not found or available for viewing.'
                        key={"portal-search-result-portal-accounts-table"}
                      />
                    </div>
                    <div id="search-results-tabs-drivers-tab"
                         className="tab-pane fade">
                      <DriversTable
                        drivers = {this.state.searchResultsDrivers}
                        message_if_none = 'Driver not found or available for viewing.'
                        key={"portal-search-result-drivers-table"}
                      />
                    </div>
                    <div id="search-results-tabs-customers-tab"
                         className="tab-pane fade">
                      <CustomersTable
                        customers = {this.state.searchResultsCustomers}
                        key={"portal-search-result-customers-table"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

if (document.getElementById(
  'react-component-g4-logistics-portal-search'
)) {
  ReactDOM.render(
    <PortalSearch />,
      document.getElementById(
        'react-component-g4-logistics-portal-search'
      )
  );
}